module.exports = __webpack_public_path__ + "static/media/thumb-nail-view-green.8bd57d9d.svg";